import {
    GET_RETURN_SUMMARY_REQUEST,
    GET_RETURN_SUMMARY_SUCCESS,
    GET_RETURN_SUMMARY_ERROR,
  } from "../actions/types";
  
  export const getReturnSummaryReducer = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_RETURN_SUMMARY_REQUEST:
        return {
          loading: true,
        };
      case GET_RETURN_SUMMARY_SUCCESS:
        return {
          ...state,
          loading: false,
          payload: payload,
        };
      case GET_RETURN_SUMMARY_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  